"use client";

// Global reduced-motion switch: framer-motion skips transform/slide animations
// site-wide (only gentle opacity fades remain), keeping the UI calm and fast.
import { MotionConfig } from "framer-motion";
import type { ReactNode } from "react";

export function MotionProvider({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="always">{children}</MotionConfig>;
}
